import {ChangeDetectionStrategy, Component, computed, HostBinding, inject, input, OnInit} from '@angular/core';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {StoryblokDirective} from '@core/directives/storyblok.directive';
import {YouTubePlayerModule} from '@angular/youtube-player';
import {StoryblokBaseComponent} from '../storyblok-base.component';
import {CookiebotConsent, CookiebotService} from '@core/services/cookiebot.service';
import {CookiebotLoaderService} from '@core/services/cookiebot-loader.service';
import {AsyncPipe} from '@angular/common';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-storyblok-video',
  templateUrl: './storyblok-video.component.html',
  styleUrls: ['./storyblok-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, YouTubePlayerModule, AsyncPipe]
})
export class StoryblokVideoComponent extends StoryblokBaseComponent implements OnInit {
  private storyblokStylingService = inject(StoryblokStylingService);
  private cookiebotService = inject(CookiebotService);
  private cookiebotLoaderService = inject(CookiebotLoaderService);


  readonly url = input<{
    url: string;
  }>();

  readonly videoId = input<string>();
  readonly _editable = input<any>();
  readonly general_styling = input<any>();

  @HostBinding('class') class: any;

  cookiebot$: Observable<CookiebotConsent>;

  videoIdFromUrl = computed(() => {
    let url = this.url()?.url || '';

    let videoId = url.split('v=').pop() || '';
    if (videoId.length <= 0) {
      return;
    }
    const ampersandPosition = videoId.indexOf('&');
    if (ampersandPosition !== -1) {
      videoId = videoId.substring(0, ampersandPosition);
    }
    return videoId;
  });

  ngOnInit(): void {
    this.class = this.storyblokStylingService.getClassList(this.general_styling(), undefined, {'col-': 12}, this.col());
    this.cookiebot$ = this.cookiebotService.cookiebotConsent.asObservable();
  }

  openCookieSettings(): void {
    this.cookiebotLoaderService.openConsentDialog();
  }
}
